'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.NRELMT = window.NRELMT || {};
NRELMT.Data = {};
NRELMT.Utils = {};
NRELMT.Render = {};
'use strict';

NRELMT.BaseModel = function () {
  this.defaults = {};
};

NRELMT.BaseModel.prototype._data = {};
NRELMT.BaseModel.prototype._dataRaw = {};

NRELMT.BaseModel.prototype.load = function (dataOb) {
  if (_.isEmpty(this._data)) {
    dataOb = dataOb || {};
    this._dataRaw = _.clone(dataOb);
    this._data = this._addDefaultVals(dataOb);
  } else {// console.log('no _data')
    // some friendly err here
  }

  return this;
};

NRELMT.BaseModel.prototype._addDefaultVals = function (dataOb) {
  var _this = this,
      data = _.clone(dataOb),
      defaultsKeys = _.keys(this.defaults);

  if (defaultsKeys.length > 0) {
    _.each(defaultsKeys, function (key) {
      if (typeof data[key] === 'undefined') {
        data[key] = _this.defaults[key];
      }
    });
  }

  return data;
};

NRELMT.BaseModel.prototype.set = function (key, val) {
  var _set = function _set(obj, prop, value) {
    try {
      if (typeof prop === 'string') {
        prop = prop.split('.');
      }

      if (prop.length > 1) {
        var e = prop.shift();

        _set(obj[e] = Object.prototype.toString.call(obj[e]) === '[object Object]' ? obj[e] : {}, prop, value);
      } else {
        obj[prop[0]] = value;
      }
    } catch (err) {
      console.log('Error setting property ' + key + ' on model', err);
    }
  };

  if (_typeof(key) === 'object' && !_.isEmpty(key)) {
    _.each(_.keys(key), function (k) {
      _set.apply(this, [this._data, k, key[k]]);
    }, this);
  } else {
    _set.apply(this, [this._data, key, val]);
  }

  return this;
};

NRELMT.BaseModel.prototype.get = function (key) {
  var retVal,
      keysArr,
      _get = function _get(key) {
    var r;

    try {
      r = this._data[key];
    } catch (err) {
      console.log('no property ' + key + ' to get from model', err);
    }

    return r;
  },
      _deepGet = function _deepGet(arr) {
    var r, tmpOb;

    try {
      tmpOb = _get.apply(this, [arr.shift()]);

      _.each(arr, function (k) {
        tmpOb = tmpOb[k];
      });

      r = tmpOb;
    } catch (err) {
      console.log('no property ' + key + ' to get from model', err);
    }

    return r;
  };

  if (key) {
    keysArr = key.split('.');

    if (keysArr.length > 1) {
      retVal = _deepGet.apply(this, [keysArr]);
    } else {
      retVal = _get.apply(this, [key]);
    }
  } else {
    retVal = this._data;
  }

  return retVal;
};

NRELMT.BaseModel.prototype.fetch = function () {};

'use strict';

NRELMT.Feature = function Feature(dataOb) {
  this.load(dataOb); // easiest way to do a default faux-computed prop

  if (!this.get('displayName')) {
    this.set('displayName', this.get('id'));
  } // set textParams as an instance of our textParams model for smart defaults


  this.set('textParams', new NRELMT.PointText(this.get('textParams')));
};

NRELMT.Feature.prototype = Object.create(NRELMT.BaseModel.prototype);

NRELMT.Feature.prototype.getTextColorClass = function getTextColorClass(powerClass) {
  if (powerClass !== 'p3' && powerClass !== 'p4') {
    this.get('textParams').set('textColor', 'dark');
  }

  return ' ' + this.get('textParams').get('textColor');
};

NRELMT.Feature.prototype.getCenteredTextTransform = function getTopTextTransform(translateArr) {
  return this.get('textParams').getTextTransform(translateArr);
};

NRELMT.Feature.prototype.getTopTextTransform = function getTopTextTransform(translateArr) {
  // massage x and y translations vals by taking mod defined in stateData (or passthrough)
  // make sure to subtract 6 from the y because it looks good.
  return this.get('textParams').getTextTransform(translateArr, [0, -6]);
};

NRELMT.Feature.prototype.getBottomTextTransform = function getBottomTextTransform(translateArr) {
  // massage x and y translations vals by taking mod defined in stateData (or passthrough)
  // make sure to add 7 to the y because it looks good.
  return this.get('textParams').getTextTransform(translateArr, [0, +7]);
};

'use strict';

NRELMT.PointText = function PointText(dataOb) {
  this.load(dataOb);
};

NRELMT.PointText.prototype = Object.create(NRELMT.BaseModel.prototype);
NRELMT.PointText.prototype.defaults = {
  textColor: 'light',
  posModX: function posModX(x) {
    return x;
  },
  posModY: function posModY(x) {
    return x;
  }
}; // Where the initial val for centerArr is the result of a call to D3's path.centroid(d)

NRELMT.PointText.prototype.getTranslateArr = function getTextTransform(centerArr, modifierArr) {
  modifierArr = modifierArr || [0, 0];
  return [this.get('posModX')(centerArr[0]) + modifierArr[0], this.get('posModY')(centerArr[1]) + modifierArr[1]];
}; // Where the initial val for centerArr is the result of a call to D3's path.centroid(d)


NRELMT.PointText.prototype.getTextTransform = function getTextTransform(centerArr, modifierArr) {
  return 'translate(' + this.getTranslateArr(centerArr, modifierArr) + ')';
};

'use strict';

NRELMT.BaseCollection = function BaseCollection(dataOb) {
  this.load(dataOb);
};

NRELMT.BaseCollection.prototype = Object.create(NRELMT.BaseModel.prototype);
NRELMT.BaseCollection.prototype.model = NRELMT.BaseModel;

NRELMT.BaseCollection.prototype.createIfNotExists = function createIfNotExists(id) {
  if (!this.get(id)) {
    this.set(id, new this.model({
      id: id
    }));
  }
};

NRELMT.BaseCollection.prototype._addDefaultVals = function (dataOb) {
  var _this = this,
      data = {};

  _.each(dataOb, function (ob) {
    data[ob.id] = new _this.model(ob);
  });

  return data;
};

'use strict';

NRELMT.FeatureCollection = function FeatureCollection(dataOb) {
  this.load(dataOb);
};

NRELMT.FeatureCollection.prototype = Object.create(NRELMT.BaseCollection.prototype);
NRELMT.FeatureCollection.prototype.model = NRELMT.Feature;

NRELMT.FeatureCollection.prototype.getDisplayName = function getDisplayName(name) {
  this.createIfNotExists(name);
  return this.get(name).get('displayName');
};

NRELMT.FeatureCollection.prototype.getTextStyle = function getTextStyle(name, d) {
  this.createIfNotExists(name);
  return this.get(name).getTextColorClass(d);
};

NRELMT.FeatureCollection.prototype.getTopTextTransform = function getTopTextTransform(name, transArr) {
  this.createIfNotExists(name);
  return this.get(name).getTopTextTransform(transArr);
};

NRELMT.FeatureCollection.prototype.getBottomTextTransform = function getBottomTextTransform(name, transArr) {
  this.createIfNotExists(name);
  return this.get(name).getBottomTextTransform(transArr);
};

'use strict';

NRELMT.Utils.quadTree = {}; // Find the nodes within the specified rectangle.

NRELMT.Utils.quadTree._clusterSearch = function _clusterSearch(quadtree, x0, y0, x3, y3) {
  var validData = [];
  quadtree.visit(function (node, x1, y1, x2, y2) {
    var p = node.point;

    if (p) {
      p.selected = p[0] >= x0 && p[0] < x3 && p[1] >= y0 && p[1] < y3;

      if (p.selected) {
        validData.push(p);
      }
    }

    return x1 >= x3 || y1 >= y3 || x2 < x0 || y2 < y0;
  });
  return validData;
}; // {
//   points: randoms.features,
//   path: path,
//   clusterRange: 5,
//   width: w,
//   height: h
// }


NRELMT.Utils.quadTree.getClusterPoints = function getClusterPoints(ob) {
  var clusterPoints = [],
      pointsRaw = ob.points.map(function (d, i) {
    var point = ob.path.centroid(d);
    point.push(i);
    return point;
  }),
      quadtree = d3.geom.quadtree()(pointsRaw),
      _centerPointReducer = function _centerPointReducer(prev, current) {
    return [prev[0] + current[0], prev[1] + current[1]];
  };

  for (var x = 0; x <= ob.width; x += ob.clusterRange) {
    for (var y = 0; y <= ob.height; y += ob.clusterRange) {
      var searched = NRELMT.Utils.quadTree._clusterSearch(quadtree, x, y, x + ob.clusterRange, y + ob.clusterRange),
          centerPoint = searched.reduce(_centerPointReducer, [0, 0]);

      centerPoint[0] = centerPoint[0] / searched.length;
      centerPoint[1] = centerPoint[1] / searched.length;
      centerPoint.push(searched);

      if (centerPoint[0] && centerPoint[1]) {
        clusterPoints.push(centerPoint);
      }
    }
  }

  return clusterPoints;
};

'use strict'; // {
//   svgEl: 'someEl',
//   pointSizeScale: fn,
//   data: 'clusterPoints',
// }


NRELMT.Render.clusterPoints = function clusterPoints(ob) {
  var cb = ob.cb || function () {};

  var chain = ob.svgEl.selectAll('.centerPoint').data(ob.data).enter().append('circle').attr('class', 'centerPoint').attr('cx', function (d) {
    return d[0];
  }).attr('cy', function (d) {
    return d[1];
  }).attr('r', function (d) {
    return ob.pointSizeScale(d[2].length);
  });
  cb(ob.data, chain);
  return chain;
};

'use strict'; // {
//   svgEl: 'someEl',
//   size: 100,
//   state: state
//   path: path,
//   cb: cb
// }


NRELMT.Render.miniState = function miniState(ob) {
  var cb = ob.cb || function () {},
      projection = d3.geo.mercator().scale(1000).translate([ob.size / 2, ob.size / 2]).precision(0.1),
      path = d3.geo.path().projection(projection),
      centroid = path.centroid(ob.state),
      chain = ob.svgEl.append('svg').attr('class', 'mini-state').attr('width', ob.size).attr('height', ob.size),
      g = chain.append('g'),
      zoom = d3.behavior.zoom().translate([0, 0]).scale(1).scaleExtent([1, 8]).on('zoom', function () {
    NRELMT.Render.miniState.zoomed(g);
  });

  if (isNaN(centroid[0])) {
    return;
  }

  g.insert('path').datum(ob.state).attr('class', 'mini-state-item').attr('d', path); // chain.insert('text')
  //   .datum(state)
  //   .text(function(d) {
  //     return d.properties.NAME;
  //   })
  //   .attr('class','state-name')
  //   .attr('transform', 'translate('+0+',' +ob.size/2+')');
  // chain.append('circle')
  //   .attr('cx', ob.size/2)
  //   .attr('cy', ob.size/2)
  //   .attr('fill', '#ff0000')
  //   .attr('r', 2)

  var bounds = path.bounds(ob.state),
      dx = bounds[1][0] - bounds[0][0],
      dy = bounds[1][1] - bounds[0][1],
      x = (bounds[0][0] + bounds[1][0]) / 2,
      y = (bounds[0][1] + bounds[1][1]) / 2,
      scale = 1 / Math.max(dx / ob.size, dy / ob.size),
      translate = [ob.size / 2 - scale * x, ob.size / 2 - scale * y];
  zoom.translate(translate).scale(scale).event(g);
  cb({
    translate: translate,
    scale: scale
  }, chain);
  return chain;
};

NRELMT.Render.miniState.zoomed = function zoomed(g) {
  g.style('stroke-width', 1.5 / d3.event.scale + 'px');
  g.attr('transform', 'translate(' + d3.event.translate + ')scale(' + d3.event.scale + ')');
};

'use strict'; // {
//   svgEl: 'someEl',
//   path: 'aPath',
//   cb: a callback,
//   data: a url to fetch state data 'js/usStatesTopo.json'
// }


NRELMT.Render.states = function states(ob) {
  var cb = ob.cb || function () {};

  var chain = ob.svgEl.selectAll('.nrelmt-state-boundary').data(ob.data).enter().append('path').attr('class', 'nrelmt-state-boundary').attr('id', 'land').attr('d', ob.path);
  cb(ob.data, chain);
  return chain;
};